import Annotation from './annotation';
import controller from "./controller";
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';

export default {
    name: 'AnnotationFeature',

    components: {
        Annotation
    },

    computed: {
        ...mapState('annotation', {
            isVisible: 'isVisible',
            annotations: 'items'
        })
    },

    watch: {
        isVisible: function () {
            this.object.visible = this.isVisible;
        }
    },

    created: function () {
        controller.registerFeature(this);
        this.object = new THREE.Group();
        this.object.name = "Annotation Container";
        VR.scene.add(this.object);
    },

    destroyed: function () {
        VR.scene.add(this.object);
        disposeObject(this.object);
    },

    methods: {
        ...mapMutations('annotation', {
            setVisibility: 'SET_VISIBILITY',
            setShowDetails: 'SET_SHOW_DETAILS',
            remove: 'REMOVE',
            deleteByAuthor: 'DELETE_FOR_AUTHOR',
            changeText: 'CHANGE_TEXT',
            updateSeeThrough: 'UPDATE_SEE_THROUGH'
        }),

        ...mapActions('annotation', ['add', 'deleteByModel', 'deleteAll']),

        ...mapGetters('annotation', {
            getAllAnnotationsAddedModelIds: 'getAllAnnotationsAddedModelIds',
            getAllAnnotations: 'getAllAnnotations',
            getSeeThroughValue: 'getSeeThroughValue'
        }),

        pickAnnotation: function (event) {
            let pick = event.pickingData;

            let object = pick.object;

            if (!object || object.parent.name !== TooltipTypeEnum.ANNOTATION) {
                return false;
            }

            while (object && !object.annotationId) {
                object = object.parent;
            }

            return object && {
                intersect: pick,
                data: this.annotations[object.annotationId]
            }
        },

        isAnnotationOnHelperObject: function (annotationId) {
            if (!this.annotations[annotationId]?.location?.modelId) {
                return false;
            }
            return modelManager.getModelType(this.annotations[annotationId].location.modelId) === ModelTypeEnum.HELPER_OBJECT;
        }
    },
};
